import { produce } from "immer"
import { remove } from "ramda"
import type { Project } from "../projects/projects.types"
import {
  MAP_SELECTOR_DESELECT_MAP,
  MAP_SELECTOR_SELECT_MAP,
  MAP_SELECTOR_SET_SELECTABLE,
  MAP_SELECTOR_SET_SELECTED_LIST
} from "./map-selector.actions"
import type { IMapSelectorState, MapSelectorActions } from "./map-selector.types"

const mapSelectorInitialState: IMapSelectorState = {
  selectedProjects: [],
  selectable: true
}

export function mapSelectorReducer(
  currentState: IMapSelectorState | undefined,
  action: MapSelectorActions
): IMapSelectorState {
  const state = currentState ?? mapSelectorInitialState
  switch (action.type) {
    case MAP_SELECTOR_SELECT_MAP:
      return selectMap(state, action.payload as Project)
    case MAP_SELECTOR_DESELECT_MAP:
      return deselectMap(state, action.payload as Project)
    case MAP_SELECTOR_SET_SELECTED_LIST:
      return setSelected(state, action.payload as Project[])
    case MAP_SELECTOR_SET_SELECTABLE:
      return setSelectable(state, action.payload as boolean)
    default:
      return state
  }
}

function selectMap(currentState: IMapSelectorState, project: Project): IMapSelectorState {
  return produce(currentState, (draftState: IMapSelectorState) => {
    draftState.selectedProjects.push(project)
  })
}

function deselectMap(currentState: IMapSelectorState, project: Project): IMapSelectorState {
  return produce(currentState, (draftState: IMapSelectorState) => {
    const isProject: boolean = project.id !== undefined
    const index: number = draftState.selectedProjects.findIndex((selectedProject: Project) => {
      return isProject ? project.id === selectedProject.id : project.metaDataId === selectedProject.metaDataId
    })
    if (index !== -1) {
      draftState.selectedProjects = remove(index, 1, draftState.selectedProjects)
    }
  })
}

function setSelected(currentState: IMapSelectorState, projects: Project[]): IMapSelectorState {
  return produce(currentState, (draftState: IMapSelectorState) => {
    draftState.selectedProjects = projects
  })
}

function setSelectable(currentState: IMapSelectorState, selectable: boolean): IMapSelectorState {
  return produce(currentState, (draftState: IMapSelectorState) => {
    draftState.selectable = selectable
  })
}
